import React from "react";
import { Box, Button, type ButtonProps, styled, TableCell } from "@mui/material";
import { TOPBARHEIGHT } from "../../../common/constants";
import { Paragraph } from "./Typography";
import type { HeadCell, Size } from "../../../types";

export const AccountWrap = styled(Box)<{ size?: Size }>(() => ({
    background: `#ffffff`,
    maxWidth: 1050,
    width: `100%`,
    margin: `${TOPBARHEIGHT + 24}px auto 0`,
}));

export const ModalButtonWrap = styled(Box)(() => ({
    textAlign: `right`,
    marginTop: `auto`,
    "& button": {
        marginLeft: `12px`,
    },
}));

export const SecondaryButton: React.FC<ButtonProps> = ({ children, ...props }) => (
    <Button
        size="small"
        variant="contained"
        sx={{
            border: `none`,
            color: `#333`,
            background: `#FFF`,
            padding: `4px 8px`,
            minWidth: `unset`,
            borderRadius: 2,
            "&:hover": {
                background: `#F5F4F2`,
            },
        }}
        {...props}
    >
        {children}
    </Button>
);

export const ModalBox = styled(Box)<{ size?: string }>(({ size }) => ({
    display: `flex`,
    flexDirection: `column`,
    minHeight: size === `small` ? `100%` : `calc(100% - 10px)`,
    padding: `40px 30px 30px`,
}));

export const LiParagraph = styled(Paragraph)(() => ({
    margin: 0,
}));

export const GradientTop = styled(Box)(({ theme }) => ({
    height: 10,
    background: `linear-gradient(to right,${theme.palette.account.accent},${
        theme.palette.account.accentGradientEnd || `#999`
    })`,
}));

export const EarningBox = styled(Box)<{ box?: string }>(({ box, theme }) => ({
    ...(box === `payout` ? { borderRadius: `16px 0 0 16px` } : { borderRadius: `0 16px  16px 0` }),
    [theme.breakpoints.down(`sm`)]: {
        ...(box === `payout` ? { borderRadius: `16px 16px 0 0` } : { borderRadius: `0 0 16px 16px` }),
    },
    textAlign: `left`,
    display: `flex`,
    flexWrap: `wrap`,
    alignItems: `center`,
    justifyContent: `left`,
    backgroundColor: `#FFF`,
    height: `100%`,
    padding: `24px 24px 16px`,
    border: `1px solid #E1E1E1`,
}));

export const DollarTitles = styled(Box)<{ sx?: Record<string, unknown> }>(({ sx = {} }) => ({
    ...(sx as Record<string, string>),
    flex: `1 0 99%`,
    fontSize: `35px`,
    fontWeight: 900,
    margin: 0,
}));

export const LiTableCell = styled(TableCell)<{ sx?: Record<string, unknown> }>(({ sx = {} }) => ({
    fontWeight: 600,
    ...(sx as Record<string, string>),
}));

export const shoppingTableHeadCells: HeadCell[] = [
    {
        id: `date`,
        numeric: false,
        disablePadding: false,
        align: `left`,
        label: `Date`,
        sx: { width: 105 },
    },
    {
        id: `store`,
        numeric: false,
        disablePadding: false,
        label: `Description`,
        colSpan: 2,
    },
    {
        id: `cashback`,
        numeric: false,
        disablePadding: false,
        align: `right`,
        label: `Cash Back`,
        sx: { width: 135 },
        editable: `cashBackHeader`,
    },
    {
        id: `status`,
        numeric: false,
        disablePadding: false,
        align: `right`,
        label: `Status`,
        sx: { "& span": { marginRight: `12px !important` }, width: 120 },
    },
    {
        id: `popup`,
        numeric: false,
        disablePadding: false,
        align: `left`,
        label: ``,
        sx: { width: 70 },
    },
];

export const shoppingTableSatuses = [
    {
        name: `All Statuses`,
        value: `all`,
    },
    { name: `Earned`, value: `earned` },
    { name: `Pending`, value: `pending` },
    { name: `Ineligible`, value: `ineligible` },
];
